import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import TeethMap from '@/components/Teeth/Map.vue';
import Money from "@/components/Money.vue";
import Modal from "@/components/Modal.vue";
import User from '@/components/User.vue';
import CustomSwitch from "@/components/CustomSwitch.vue";
import PlanTable from "@/Pages/People/Customer/TreatmentPlan/PlanTable.vue";
import Plan from "@/Pages/People/Customer/TreatmentPlan/Plan.vue";
import CompanyPrintHeader from '@/components/Company/CompanyPrintHeader.vue';
let PrintPlan = class PrintPlan extends Vue {
    id;
    groupedByColorPlan = {};
    plan = {};
    groupedByToothPlan = {};
    showSeparated = false;
    printSeparately = false;
    renderColorSwitch = false;
    groupedMode = false;
    isAdultTeethMapShown = true;
    isKidTeethMapShown = false;
    isCommentsHidden = false;
    teethMapSize = 30;
    getMyCompany;
    getCustomer;
    get company() {
        return this.getMyCompany('mine');
    }
    get customer() {
        return this.getCustomer(this.plan.customerId);
    }
    treatmentPlanNote() {
        const printTemplates = this.company.printTemplates;
        if (!printTemplates)
            return this.$t('print plan note');
        if (printTemplates.treatmentPlan && printTemplates.treatmentPlan.length > 0)
            return printTemplates.treatmentPlan;
        return this.$t('print plan note');
    }
    shown() {
        const { TreatmentPlan } = this.$FeathersVuex;
        let data = TreatmentPlan.getFromStore('temp');
        if (data) {
            delete data._id;
            this.plan = data.model.plan;
            this.groupedByToothPlan = data.model.groupedByTooth;
            this.groupedByColorPlan = data.model.groupedByColor;
            this.renderColorSwitch = data.model.groupedByColor.length > 1;
            this.groupedMode = data.model.groupedMode;
            new TreatmentPlan({
                _id: 'temp'
            });
        }
        this.showSeparated = false;
        this.printSeparately = false;
    }
    hidden() {
        var $printSection = document.getElementById("printSection");
        if ($printSection) {
            $printSection.remove();
        }
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
    print() {
        var printContent = document.getElementById("printContent");
        if (!printContent)
            return;
        var domClone = printContent.cloneNode(true);
        var $printSection = document.getElementById("printSection");
        if (!$printSection) {
            $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        }
        $printSection.innerHTML = "";
        $printSection.appendChild(domClone);
        window.print();
    }
};
__decorate([
    Prop()
], PrintPlan.prototype, "id", void 0);
PrintPlan = __decorate([
    Component({
        components: {
            Plan,
            PlanTable,
            CustomSwitch,
            Modal,
            Money,
            User,
            TeethMap,
            CompanyPrintHeader,
        },
        computed: {
            ...mapGetters('my-company', { getMyCompany: 'get' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
        },
    })
], PrintPlan);
export default PrintPlan;
